import { render } from "./TopNavigation.vue?vue&type=template&id=3e8478ec"
import script from "./TopNavigation.vue?vue&type=script&lang=js"
export * from "./TopNavigation.vue?vue&type=script&lang=js"
script.render = render

export default script